export default function Hero() {
  return (
    <section id="hero" className="relative w-full pt-20 md:pt-24">
      <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          {/* Text Content */}
          <div className="flex-1 w-full max-w-2xl">
            {/* Tag before H1 */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm font-medium mb-4 md:mb-5">
              <i className="ri-bookmark-line"></i>
              <span>韩漫 · 日漫 · 国漫一站尽享</span>
            </div>

            {/* H1: site name + core positioning */}
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3 md:mb-4">
              香蕉漫画网
              <span className="text-primary-500"> | </span>
              韩漫日漫国漫精准分类平台
            </h1>

            {/* Slogan after H1 */}
            <p className="text-base md:text-lg text-foreground-600 font-medium mb-5 md:mb-6">
              国产漫画、日本漫画、韩国漫画精准分类，漫迷的细分阅读指南
            </p>

            {/* Intro paragraph */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 md:mb-8">
              香蕉漫画网汇聚海量韩漫、日漫、国漫资源，国产漫画、日本漫画、韩国漫画分类清晰、更新及时。
              无论你是追更党还是补番党，都能在这里快速找到心仪的漫画类型，享受一站式精准阅读体验。
              从热血战斗到恋爱治愈，从悬疑推理到玄幻修真，八大细分题材覆盖所有漫迷的阅读偏好。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-earth-line text-primary-600 text-sm md:text-base"></i>
                </div>
                <div>
                  <div className="text-xs md:text-sm font-semibold text-foreground-900">韩漫日漫国漫全覆盖</div>
                  <div className="text-xs text-foreground-500">三大漫画体系完整收录</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                  <i className="ri-refresh-line text-accent-700 text-sm md:text-base"></i>
                </div>
                <div>
                  <div className="text-xs md:text-sm font-semibold text-foreground-900">每日精筛优质章节</div>
                  <div className="text-xs text-foreground-500">紧跟连载进度即时上架</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0">
                  <i className="ri-shield-check-line text-secondary-700 text-sm md:text-base"></i>
                </div>
                <div>
                  <div className="text-xs md:text-sm font-semibold text-foreground-900">纯净阅读无广告弹窗</div>
                  <div className="text-xs text-foreground-500">清爽环境专注追漫</div>
                </div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="#cards"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-compass-3-line"></i>
                开始探索
              </a>
              <a
                href="#index"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border-2 border-foreground-300 text-foreground-700 font-semibold text-sm md:text-base hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-grid-line"></i>
                了解分类
              </a>
            </div>
          </div>

          {/* Hero Image */}
          <div className="flex-1 w-full max-w-xl lg:max-w-none img-container">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20comic%20book%20world%20illustration%20with%20stacked%20colorful%20comic%20books%20and%20manga%20volumes%2C%20warm%20inviting%20atmosphere%2C%20floating%20panels%20with%20characters%2C%20coral%20orange%20and%20cream%20color%20palette%2C%20dreamlike%20composition%2C%20editorial%20illustration%20style%2C%20no%20text%20or%20letters%2C%20beautiful%20and%20harmonious&width=900&height=650&seq=hero-main&orientation=landscape"
              alt="香蕉漫画网主视觉 - 缤纷漫画世界"
              className="w-full h-auto rounded-2xl object-cover"
              onError={(e) => {
                const container = e.currentTarget.closest('.img-container');
                if (container) container.classList.add('hidden');
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}